import { UserAPI } from '@business/api/user';
import { Blocs } from '@business/blocs';
import { UserId, EmailItemResponse } from '@business/entities/account';
import { OrgId } from '@business/entities/organization';
import { CommonService } from '@business/services';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export class NewEmailBloc extends BaseBloc {
  private readonly activityBloc = resolve(Blocs.contactActivity);
  private readonly organizationBloc = resolve(Blocs.organization);
  private readonly contactBloc = resolve(Blocs.contact);
  private readonly emailBloc = resolve(Blocs.email);

  constructor(private readonly userId: UserId) {
    super();
  }

  loading = new LoadingState();

  contacts$ = this.contactBloc.contacts$;

  emails$ = new BehaviorSubject<EmailItemResponse[]>([]);

  searchOrganizations = (search: string) => {
    return this.organizationBloc.searchOrganizations(search).pipe(map(data => CommonService.selectItems(data.data, 'name', 'id')));
  };

  public onInit() {
    return UserAPI.fetchEmails(this.userId).pipe(tap(emails => this.emails$.next(emails)));
  }

  fetchContacts(orgId: OrgId) {
    this.contactBloc.fetchContacts({ orgId }).subscribe();
  }

  sendEmail = this.activityBloc.sendEmail;
  sendReply = this.emailBloc.sendReply;
  previewEmail = this.activityBloc.previewEmail;
  sendTestEmail = this.activityBloc.sendTestEmail;
}
